import { render, staticRenderFns } from "./flow-add-or-update.vue?vue&type=template&id=b1ccbdf4"
import script from "./flow-add-or-update.vue?vue&type=script&lang=js"
export * from "./flow-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./flow-add-or-update.vue?vue&type=style&index=0&id=b1ccbdf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports